/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';
import type { WinningCriteria } from './WinningCriteria';
import {
    WinningCriteriaFromJSON,
    WinningCriteriaFromJSONTyped,
    WinningCriteriaToJSON,
    WinningCriteriaToJSONTyped,
} from './WinningCriteria';
import type { RewardGrantResponse } from './RewardGrantResponse';
import {
    RewardGrantResponseFromJSON,
    RewardGrantResponseFromJSONTyped,
    RewardGrantResponseToJSON,
    RewardGrantResponseToJSONTyped,
} from './RewardGrantResponse';

/**
 * Collection contains the user's reward stats/progress.
 * @export
 * @interface SponsoredRewardResponse
 */
export interface SponsoredRewardResponse {
    /**
     * 
     * @type {WinningCriteria}
     * @memberof SponsoredRewardResponse
     */
    winningCriteria: WinningCriteria;
    /**
     * 
     * @type {RewardConfigResponse}
     * @memberof SponsoredRewardResponse
     */
    rewardConfig?: RewardConfigResponse;
    /**
     * 
     * @type {RewardGrantResponse}
     * @memberof SponsoredRewardResponse
     */
    rewardGrant?: RewardGrantResponse;
    /**
     * Starting rank for this reward (1-indexed). Only used for TOP_OVERALL_XP_GAINER.
     * @type {number}
     * @memberof SponsoredRewardResponse
     */
    rankStart?: number;
    /**
     * Ending rank for this reward (inclusive). Only used for TOP_OVERALL_XP_GAINER.
     * @type {number}
     * @memberof SponsoredRewardResponse
     */
    rankEnd?: number;
}



/**
 * Check if a given object implements the SponsoredRewardResponse interface.
 */
export function instanceOfSponsoredRewardResponse(value: object): value is SponsoredRewardResponse {
    if (!('winningCriteria' in value) || value['winningCriteria'] === undefined) return false;
    return true;
}

export function SponsoredRewardResponseFromJSON(json: any): SponsoredRewardResponse {
    return SponsoredRewardResponseFromJSONTyped(json, false);
}

export function SponsoredRewardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SponsoredRewardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'winningCriteria': WinningCriteriaFromJSON(json['winningCriteria']),
        'rewardConfig': json['rewardConfig'] == null ? undefined : RewardConfigResponseFromJSON(json['rewardConfig']),
        'rewardGrant': json['rewardGrant'] == null ? undefined : RewardGrantResponseFromJSON(json['rewardGrant']),
        'rankStart': json['rankStart'] == null ? undefined : json['rankStart'],
        'rankEnd': json['rankEnd'] == null ? undefined : json['rankEnd'],
    };
}

export function SponsoredRewardResponseToJSON(json: any): SponsoredRewardResponse {
    return SponsoredRewardResponseToJSONTyped(json, false);
}

export function SponsoredRewardResponseToJSONTyped(value?: SponsoredRewardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'winningCriteria': WinningCriteriaToJSON(value['winningCriteria']),
        'rewardConfig': RewardConfigResponseToJSON(value['rewardConfig']),
        'rewardGrant': RewardGrantResponseToJSON(value['rewardGrant']),
        'rankStart': value['rankStart'],
        'rankEnd': value['rankEnd'],
    };
}

